export enum PepTypeVariant {
  NotPep = 'not_pep',
  Pep = 'pep',
  PepAssociate = 'pep_associate',
}
